import { ethers } from 'ethers'
import { createContext } from 'react'

const WalletContext = createContext<{ signer?: ethers.providers.JsonRpcSigner }>({
    signer: undefined,
})

export default WalletContext
